
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("779"), __webpack_require__.e("483"), __webpack_require__.e("74"), __webpack_require__.e("362")]).then(() => (() => (__webpack_require__(3855))));
},
"./TeacherNavShell": () => {
return __webpack_require__.e(/*  | __federation_expose_TeacherNavShell */ "394").then(() => (() => (__webpack_require__(4837))));
},
"./AdminNavShell": () => {
return __webpack_require__.e(/*  | __federation_expose_AdminNavShell */ "515").then(() => (() => (__webpack_require__(8038))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };